export const isTelegramApp = () => {
  return (window as any).Telegram?.WebApp?.initData !== '';
};
